import { action } from 'easy-peasy';
import { IActionRemoveCarePlanGoal } from '../types';

const removeCarePlanGoal: IActionRemoveCarePlanGoal = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default removeCarePlanGoal;
